import { APIRepository } from "~/context/Shared/infrastructure/APIRepository";
import { vectiAppApiUrl } from "~/context/Shared/infrastructure/Config";
import { CashFlowDataRepository } from "../domain/CashFlowDataRepository";
import { CashFlowReport } from "../domain/CashFlowReport";


export function createApiCashFlowDataRepository(): CashFlowDataRepository {
  return new ApiCashFlowDataRepository();
}

export class ApiCashFlowDataRepository
  extends APIRepository
  implements CashFlowDataRepository {
  constructor() {
    super(vectiAppApiUrl());
  }

  getCashFlowReport(companyUid: string): Promise<CashFlowReport> {
    console.log("getCashFlowReport companyUid: " + companyUid);
    return this.doGet<CashFlowReport>("/api/cashflowsdata/company/" + companyUid.toString() + "/cashFlow15DaysByCompany");
  }
}